export enum UserActivityEventEnum {
  // Note: These are just constants that are used in the frontend code
  // All event values are stored in the database as strings
  // This list DOES NOT include all possible event values
  SITE_MODIFICATION = 'Site Modification',
}
